import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useState, useEffect } from 'react';
import { ProgressWrapper, BackCircle, ProgressCircle } from './styled.es.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var Progress = function Progress(_a) {
  var _b = _a,
      _b$size = _b.size,
      size = _b$size === void 0 ? "md" : _b$size,
      _b$progress = _b.progress,
      progress = _b$progress === void 0 ? "indeterminate" : _b$progress,
      _b$transitionDelay = _b.transitionDelay,
      transitionDelay = _b$transitionDelay === void 0 ? 850 : _b$transitionDelay,
      _b$strokeWidth = _b.strokeWidth,
      strokeWidth = _b$strokeWidth === void 0 ? 3.6 : _b$strokeWidth,
      props = __objRest(_b, ["size", "progress", "transitionDelay", "strokeWidth"]);

  var center = 44;
  var radius = 22 - strokeWidth / 2;
  var circumference = 2 * Math.PI * radius;

  var _useState = useState(circumference),
      offset = _useState[0],
      setOffset = _useState[1];

  var _useState2 = useState(true),
      isIndeterminate = _useState2[0],
      setIsIndeterminate = _useState2[1];

  useEffect(function () {
    setIsIndeterminate(progress === "indeterminate");
  }, [progress]);
  useEffect(function () {
    if (typeof progress !== "number") {
      return;
    }

    var progressOffset = (1 - progress) * circumference;
    setOffset(progressOffset);
  }, [setOffset, circumference, progress, offset]);
  return (
    /* @__PURE__ */
    React.createElement(ProgressWrapper, __spreadProps(__spreadValues({
      size: size,
      progress: progress,
      title: isIndeterminate ? "Loading" : "Progress"
    }, props), {
      viewBox: "22 22 44 44"
    }), !isIndeterminate &&
    /* @__PURE__ */
    React.createElement(BackCircle, {
      cx: center,
      cy: center,
      r: radius,
      fill: "none",
      strokeWidth: strokeWidth,
      stroke: "currentColor"
    }),
    /* @__PURE__ */
    React.createElement(ProgressCircle, {
      cx: center,
      cy: center,
      r: radius,
      fill: "none",
      strokeWidth: strokeWidth,
      stroke: "currentColor",
      progress: progress,
      strokeDasharray: circumference,
      strokeDashoffset: offset,
      transitionDelay: transitionDelay
    }))
  );
};

Progress.displayName = "Progress";
export { Progress };